import React, { useState } from "react";
import { registerUser } from "../services/api"; // Import your register API call

const Signup = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!username || !email || !password) {
      setError("Please fill in all fields.");
      setSuccess("");
      return;
    }
    setError("");
    setSuccess("");
    try {
      const res = await registerUser(username, email, password);
      if (res.message) {
        setSuccess("Account created! You can now log in.");
        setUsername("");
        setEmail("");
        setPassword("");
      } else {
        setError(res.error || "Signup failed");
      }
    } catch (err) {
      setError("Could not connect to backend.");
    }
  };

  return (
    <div style={{ maxWidth: "350px", margin: "60px auto", padding: "30px", background: "#23233a", borderRadius: "13px" }}>
      <h2 style={{ color: "#a261e7" }}>Sign Up</h2>
      {error && <div style={{ color: "#ff5860", marginBottom: "8px" }}>{error}</div>}
      {success && <div style={{ color: "#6dd06d", marginBottom: "8px" }}>{success}</div>}
      <form onSubmit={handleSignup}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "11px", borderRadius: "8px", padding: "8px" }}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "11px", borderRadius: "8px", padding: "8px" }}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{ width: "100%", marginBottom: "18px", borderRadius: "8px", padding: "8px" }}
        />
        <button type="submit" style={{ width: "100%", padding: "11px", background: "#a261e7", color: "#fff", fontWeight: "bold", borderRadius: "7px", border: "none" }}>
          Create Account
        </button>
      </form>
    </div>
  );
};

export default Signup;
